import { useGetEvent } from "../../api/event";
import logoSrc from "../../assets/logo-02-cropped.svg";
import { describeRange } from "./timeFrame";

function PrintHeader({ eventId }) {
  const { data: event } = useGetEvent(eventId);
  const eventName = event?.name ?? "";
  // Event date range on the left; per-chart captions carry each chart's own
  // time frame.
  const eventDates = describeRange({ timeFrame: "event" }, event);

  return (
    <div className="insights-print-only insights-print-header">
      <span className="insights-print-header__date">{eventDates}</span>
      <span className="insights-print-header__title">
        App report for {eventName}
      </span>
      <span className="insights-print-header__logo-wrap">
        <img
          src={logoSrc}
          alt="Congrs"
          className="insights-print-header__logo"
        />
      </span>
    </div>
  );
}

export default PrintHeader;
